<template>
  <b-card>
    <b-row>
      <b-col
        cols="12"
        class="text-center"
      >

        <h1 class="mt-3">
          ระบบได้รับเรื่องร้องทุกข์เรียบร้อยแล้ว
        </h1>

        <h1 class="mt-3">
          เลขร้องทุกข์ OCPB0000/000001
        </h1>

      </b-col>

      <b-col
        cols="12"
        class="d-flex justify-content-center mt-3 mb-4"
      >

        <b-button
          variant="outline-secondary"
          class="m-1"
        >
          พิมพ์ใบคำร้อง
        </b-button>

        <b-button
          variant="outline-primary"
          class="m-1"
          @click="HomeBtnClicked"
        >
          กลับหน้าหลัก
        </b-button>

      </b-col>
    </b-row>
  </b-card>

</template>

<script>
import {
  BRow, BCol, BButton, BCard,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BCard,
  },
  methods: {
    HomeBtnClicked() {
      this.$router.push({ name: 'dashboard-ecommerce' })
    },
  },
}
</script>

<style>

</style>
